module.exports = __webpack_public_path__ + "img/AdobeStock_295729789@3x.72b4481.png";